import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "../App.css";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const SliderTop = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="container-slider p-2 padding-container">
      <Swiper
        modules={[Autoplay, Pagination]}
        loop={true}
        autoplay={{
          delay: 302200,
          disableOnInteraction: false,
        }}
        speed={800}
        effect="slide"
        pagination={{ clickable: true }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
        className="swiper-1"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="Slider-page-1">
          <div className="content">
              <h1>Empowering Businesses with <br /><span className="orange-text">Reliable Digital Solutions</span></h1>
              <p>Professional design, development, and creative services tailored for measurable impact.</p>
           
              <Link  to = "/Services" className="cta-btn slider-btn" style={{ color: "white", textDecoration: "none" }}>EXPLORE OUR SERVICES</Link>
            </div>
            
          

            <div className="image">
                <img src="/assets/Images/Website designer-pana 1 (1).png" alt="" />


            </div>

           
           
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="Slider-page-1">
          
          <div className="content">
              <h1>Building Modern Digital  <br /><span className="orange-text">Experiences That Drive Results</span></h1>
              <p>From UI/UX and web development to graphic and motion design — we deliver structured, quality-driven solutions.</p>
              <Link  to = "/Portfolio" className="cta-btn slider-btn" style={{ color: "white", textDecoration: "none" }}>VIEW OUR PORTFOLIO</Link>

            </div>
            <div className="image">
            <img src="/assets/Images/Paper-map-cuate-3.png" alt="" />

            </div>

            
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="Slider-page-1">
          <div className="content">
              <h1 className="desgin_heading">Design. Develop. <br /> <span className="orange-text">Deliver.</span></h1>
              <p>VisionBird Technologies provides end-to-end digital services designed to enhance performance and user engagement.</p>
              <Link  to = "/Career" className="cta-btn slider-btn" style={{ color: "white", textDecoration: "none" }}>LEARN MORE</Link>
            </div>
            <div className="image">
            <img src="/assets/Images/Paper-map-cuate-2.png" alt="" />

            </div>
           
          </div>
        </SwiperSlide>

        {/* Slide 4 */} 
        <SwiperSlide>
          <div className="Slider-page-1">
          <div className="content">
              <h1>Where Creative Design <br /><span className="orange-text">Meets Technical Excellence</span>
              </h1>
              <p>We combine strategic UI/UX, modern front-end development, and professional creative content to support your business objectives.</p>
              <Link  to = "/About" className="cta-btn slider-btn" style={{ color: "white", textDecoration: "none" }}>SEE WHAT WE DO</Link>
            
            </div>

            <div className="image">
            <img src="/assets/Images/Messages-pana-2.png" alt="" />

            </div>
          
          </div>
        </SwiperSlide>

        {/* Slide 5 */}
        <SwiperSlide>
          <div className="Slider-page-1">
          <div className="content">
              <h1>Your Trusted Partner for High <br /><span className="orange-text"> Quality Digital Execution</span></h1>
              <p>We deliver well-structured, visually refined, and performance-focused digital solutions for businesses worldwide.</p>

            </div>

            <div className="image">
            <img src="/assets/Images/Privacy policy-pana 1.png" alt="" />

            </div>

          
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SliderTop;